import React, { FC } from 'react';
import Drawer from '../Drawer';
import { AddressView } from '../ra';
import { Address } from '../ra/AddressForm';
import { useEditMode } from '~/hooks/useEditModeContext';

interface Props {
  address: Address | undefined;
  open: boolean;
  heading?: string;
  onClose: () => void;
}

const AddressShow: FC<Props> = (props) => {
  const { address, heading = 'Address', open, onClose } = props;
  const { editMode } = useEditMode();

  return (
    <Drawer heading={heading} open={open} onClose={onClose} editMode={editMode}>
      {address && <AddressView address={address} />}
    </Drawer>
  );
};

export default AddressShow;
